<form [formGroup]="form" (ngSubmit)="resend()" novalidate>
  <h1 class="text-center auth-heading">
    <a [routerLink]="['/']" class="inline-block">
      <img src="assets/layout/images/wtg-logo-transparent-white.webp" alt="wtg watch this garage logo" class="app-logo">
    </a>
    <small>{{ 'auth.registration.check_email.title' | translate }}</small>
  </h1>

  <p class="text-center check-email-copy">
    {{ (hasPrefilledIdentifier ? 'auth.registration.check_email.description' : 'auth.registration.check_email.description_without_identifier') | translate }}
  </p>

  <div class="col-12 p-fluid">
    <span class="p-float-label p-input-icon-left">
      <i class="pi pi-envelope"></i>
      <input type="text" pInputText id="registration-check-email-identifier" formControlName="usernameOrEmail">
      <label for="registration-check-email-identifier">{{ 'auth.registration.check_email.username_or_email' | translate }}</label>
    </span>
  </div>

  <div class="col-12 app-form-error" *ngIf="form.controls['usernameOrEmail'].invalid && form.controls['usernameOrEmail'].touched">
    <p *ngIf="form.controls['usernameOrEmail'].errors?.required">
      {{ 'auth.registration.check_email.validation.username_or_email.required' | translate }}
    </p>
    <p *ngIf="form.controls['usernameOrEmail'].errors?.custom">
      {{ form.controls['usernameOrEmail'].errors.custom }}
    </p>
  </div>

  <div class="col-12 p-fluid">
    <button pButton pRipple
            type="submit"
            icon="pi pi-envelope"
            iconPos="left"
            class="auth-action--primary"
            [disabled]="form.invalid || isSubmitting"
            [label]="'auth.registration.check_email.button.resend' | translate"></button>
  </div>

  <div class="col-12 p-fluid">
    <button pButton pRipple
            type="button"
            icon="pi pi-arrow-left"
            iconPos="left"
            class="auth-action--back"
            [routerLink]="['/login']"
            [label]="'auth.login.button.sign_in' | translate"></button>
  </div>
</form>
